import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import {
    ResponsiveContainer,
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";

export interface ISCurveChartProps {
    data: {
        name: string;
        planned: number;
        actual: number;
    }[];
}

export const SCurveChart: React.FC<ISCurveChartProps> = ({ data }) => {
    return (
        <Paper
            elevation={0}
            sx={{ p: 3, borderRadius: 2, "background-color": "unset" }}
        >
            <Box sx={{ mb: 2 }}>
                <Typography variant="h5" color="text.primary">
                    Gráfico de Curva S
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Representa o acúmulo custo ao longo do tempo, permitindo
                    comparar o planejado com o realizado.
                </Typography>
            </Box>

            <Box sx={{ height: 300 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart
                        data={data}
                        margin={{ top: 10, right: 30, left: 0, bottom: 5 }}
                    >
                        <defs>
                            <linearGradient
                                id="colorPlanned"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                            >
                                <stop
                                    offset="5%"
                                    stopColor="#90caf9"
                                    stopOpacity={0.8}
                                />
                                <stop
                                    offset="95%"
                                    stopColor="#90caf9"
                                    stopOpacity={0.1}
                                />
                            </linearGradient>
                            <linearGradient
                                id="colorActual"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                            >
                                <stop
                                    offset="5%"
                                    stopColor="#f48fb1"
                                    stopOpacity={0.8}
                                />
                                <stop
                                    offset="95%"
                                    stopColor="#f48fb1"
                                    stopOpacity={0.1}
                                />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="name" />
                        <YAxis domain={[0, 100]} />
                        <Tooltip />
                        <Legend />
                        <Area
                            type="monotone"
                            dataKey="planned"
                            name="Planejado"
                            stroke="#1e88e5"
                            fillOpacity={1}
                            fill="url(#colorPlanned)"
                        />
                        <Area
                            type="monotone"
                            dataKey="actual"
                            name="Realizado"
                            stroke="#e91e63"
                            fillOpacity={1}
                            fill="url(#colorActual)"
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </Box>
        </Paper>
    );
};
